import { IconButton } from "@package/subframe/components/IconButton";
import { FeatherArrowLeft } from "@subframe/core";
import { useNavigate } from "@tanstack/react-router";

interface ProfilePageHeaderProps {
  isOwnProfile: boolean;
  canViewDirectory: boolean;
}

/**
 * The back arrow and title every detail page has. The arrow goes to People
 * Hub, so it is left out for those who can't open it.
 */
export function ProfilePageHeader({
  isOwnProfile,
  canViewDirectory,
}: ProfilePageHeaderProps) {
  const navigate = useNavigate();

  return (
    <div
      data-testid="profile-page-header"
      className="flex w-full items-center gap-2"
    >
      {canViewDirectory && (
        <IconButton
          icon={<FeatherArrowLeft />}
          aria-label="Back to People Hub"
          data-testid="profile-back-to-people"
          onClick={() => void navigate({ to: "/people" })}
        />
      )}
      <span className="grow shrink-0 basis-0 whitespace-nowrap text-metrics font-metrics text-primary-navy-800">
        {isOwnProfile ? "My profile" : "Employee profile"}
      </span>
    </div>
  );
}
